/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  message,
  DatePicker,
} from 'antd';
import {
  InfoCircleOutlined,
} from '@ant-design/icons';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import {
  deleteExpedienteMercado,
  getExpedienteMercado,
  getExpedientesMercados,
  patchExpedienteMercado,
  postExpedienteMercado,
} from 'api/empresas/expedienteDeMercado';
import { ActionsNames, hasActionPermission } from 'utils/permission/index';
// import { getEmpresa, getEmpresas } from 'api/empresas/empresas';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { getMercados } from 'api/empresas/mercado';
import { getGirosMercados } from 'api/empresas/giroDeMercado';
import { getDias } from 'api/catalogos';
import NumericInput from 'components/NumericInput';
// import address from 'utils/address';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { getZonasDeMercados } from 'api/catalogos/zonasDeMercado';
import { getPlazasDeMercados } from 'api/catalogos/plazasDeMercado';
import { getContribuyenteCaja } from 'api/empresas/contribuyentes';
import contribuyente from 'views/Tramites/GPM/configsPadrones/contribuyente';
import { getTiposDeMercado } from 'api/catalogos/tiposDeMercado';
import { getContribuyente } from 'api/empresas/contribuyente';

const { TabPane } = Tabs;
const baseURI = 'empresas/expedientes-de-mercados/';

const models = ['girodemercado'];

const ExpedienteDeMercado = ({ permission }) => {
  const { dias, estadosGlobales } = useSelector(({ catalogs }) => catalogs);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const [mercadosTemp, setMercadosTemp] = useState({ results: [] });
  const mercados = useRef({ results: [] });
  const [giros, setGiros] = useState([]);
  const [plazasDeMercado, setPlazasDeMercado] = useState([]);
  const [zonasDeMercado, setZonasDeMercado] = useState([]);
  const [tipoDeMercado, setTipoDeMercado] = useState([]);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  // const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const mercado = Form.useWatch('mercado', form);

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getExpedientesMercados({
      ...q,
      page,
    });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    let _hasAllPermission = true;
    const validatePermission = () => {
      const _hasAllViewPermission = models
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        _hasAllPermission = _hasAllViewPermission;
        setHasAllViewPermission(_hasAllViewPermission);
      }
    };
    const fetchAll = async () => {
      setLoading(true);
      const [_data, _giros, _zonas, _plazas, _tipos] = await Promise.all([
        getExpedientesMercados({ page: 1 }, true),
        getGirosMercados(),
        getZonasDeMercados(),
        getPlazasDeMercados(),
        getTiposDeMercado(),
        getDias(),
      ]);
      if (mounted) {
        setData(_data);
        setGiros(_giros);
        setZonasDeMercado(_zonas);
        setPlazasDeMercado(_plazas);
        setTipoDeMercado(_tipos);
        setLoading(false);
      }
    };
    validatePermission();
    if (_hasAllPermission) {
      fetchAll();
    }
    return () => { mounted = false; };
  }, []);

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q_contribuyente']);
      const { q_contribuyente: q } = form.getFieldsValue();
      if (q) {
        const contribuyentes = await getContribuyenteCaja({ rfc: q });
        if (contribuyentes.results.length) {
          const [selected] = contribuyentes.results;
          form.setFieldsValue({
            ...selected,
            contribuyente: selected.id,
            contribuyente_rfc: selected?.rfc || selected?.RFC || 'SIN RFC',
          });
          setContribuyenteFound([selected]);
        } else if (!contribuyentes.results.length) {
          message.info('No se encontró al Contribuyente.');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const fetchEmpresa = async (id) => {
  //   try {
  //     setLoading(true);
  //     if (id) {
  //       const _empresa = await getEmpresa(id?.id || id);
  //       if (_empresa) {
  //         setEmpresaFound({
  //           ..._empresa,
  //           nombre_comercial: `${_empresa?.clave} - ${_empresa?.nombre_comercial}`,
  //         });
  //       } else {
  //         message.info('No se encontro la empresa');
  //       }
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     onError(error, setLoading);
  //   }
  // };
  // const resetAndValidate = () => {
  //   setCiudadanoFound([]);
  //   form.resetFields(['q']);
  // };

  const resetAndValidateContribuyente = () => {
    setContribuyenteFound([]);
    form.resetFields(['q_contribuyente']);
    form.validateFields(['q_contribuyente']);
  };

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
    // setCiudadanoFound([]);
    setContribuyenteFound([]);
    setMercadosTemp({ results: [] });
    mercados.current = { results: [] };
  };

  const fetchContribuyente = async (id) => {
    setLoading(true);
    if (id) {
      const _contribuyente = await getContribuyente(id?.id || id);
      if (_contribuyente) {
        setContribuyenteFound([_contribuyente]);
        form.setFieldsValue({
          ...contribuyente,
          contribuyente: _contribuyente?.id,
          contribuyente_rfc: _contribuyente?.rfc || _contribuyente?.RFC || 'Sin RFC',
        });
      } else {
        message.info('No se encontró al contribuyente');
        setContribuyenteFound([]);
      }
    }
    setLoading(false);
  };

  // const fetchCiudadano = async (id) => {
  //   setLoading(true);
  //   if (id) {
  //     const _ciudadano = await getCiudadano(id?.id || id);
  //     if (_ciudadano) {
  //       form.setFieldsValue({
  //         ciudadano: _ciudadano?.id,
  //       });
  //       setCiudadanoFound([_ciudadano]);
  //     } else {
  //       message.info('No se encontró ciudadano');
  //       setCiudadanoFound([]);
  //     }
  //   }
  //   setLoading(false);
  // };

  const onClickEdit = async (ExpedienteDeMercadoId) => {
    setLoading(true);
    const key = selectedRowKeys[0] || ExpedienteDeMercadoId;
    const match = await getExpedienteMercado(key);
    if (match) {
      // if (match?.ciudadano) await fetchCiudadano(match.ciudadano?.id || match.ciudadano);
      if (match?.contribuyente) {
        await fetchContribuyente(match?.contribuyente?.id || match?.contribuyente);
      }
      if (match?.mercado) {
        const _mercado = await getMercados({ id: match?.mercado?.id });
        setMercadosTemp(_mercado);
      } else {
        setMercadosTemp({ results: [] });
      }
    }
    form.setFieldsValue({
      ...match,
      mercado: match.mercado?.id,
      // ciudadano: match.ciudadano?.id ?? match.ciudadano,
      contribuyente: match.contribuyente?.id ?? match.contribuyente,
    });
    setVisible(true);
    setLoading(false);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const _data = await (
        key ? patchExpedienteMercado(key, values) : postExpedienteMercado(values)
      );
      if (_data) {
        await fetchData();
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
          }
          await onClickEdit(_data.id);
        } else {
          onCancel();
        }
        setLoading(false);
        return _data;
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading);
      return false;
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteExpedienteMercado(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  // const searchEmpresa = async () => {
  //   try {
  //     setLoading(true);
  //     await form.validateFields(['q']);
  //     const { q } = form.getFieldsValue(['q']);
  //     if (q) {
  //       const _empresaFound = await getEmpresas({ q });
  //       if (_empresaFound.results.length) {
  //         const [selected] = _empresaFound.results;
  //         form.setFieldsValue({
  //           empresa: selected.id,
  //         });
  //         setEmpresaFound([{
  //           ...selected,
  //           nombre_comercial: `${selected?.clave || ''} - ${selected?.nombre_comercial}`,
  //         }]);
  //       } else if (!_empresaFound.results.length) {
  //         message.info('Empresa no encontrada');
  //         setVisibleBusquedaPadrones(true);
  //       }
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     onError(error, setLoading);
  //   }
  // };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Contribuyente',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      width: 200,
      render: (val) => (val?.nombre_completo || 'No viene indexado aun'),
    },

    {
      titleText: 'Mercado',
      dataIndex: 'mercado',
      key: 'mercado',
      width: 200,
      render: (val) => ((val?.descripcion) || 'No cuenta con registro en este campo'),
    },
    {
      titleText: 'Tipo de Puesto',
      dataIndex: 'tipos_de_mercados',
      key: 'tipos_de_mercados',
      width: 200,
      render: (val) => (tipoDeMercado?.find((t) => t.id === val)?.descripcion || 'No cuenta con tipo de mercado en su registro'),
      // render: (val) => {
      //   const _giros = val.map((e) => giros?.find((i) => i.id === e)?.descripcion);
      //   return _giros?.map((e) => ` ${e}`).toString();
      // },
    },
    {
      titleText: 'Giro principal',
      dataIndex: 'giro_principal',
      key: 'giro_principal',
      width: 200,
      render: (val) => (giros?.find((g) => g.id === val)?.descripcion || 'No cuenta con giro en su registro'),
      // render: (val) => {
      //   const _giros = val.map((e) => giros?.find((i) => i.id === e)?.descripcion);
      //   return _giros?.map((e) => ` ${e}`).toString();
      // },
    },
    {
      titleText: 'Estatus de Expediente',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const rules = {
    required: [
      { required: true },
    ],
  };

  // const searchCiudadano = async () => {
  //   try {
  //     setLoading(true);
  //     await form.validateFields(['q']);
  //     const { q } = form.getFieldsValue(['q']);
  //     if (q) {
  //       const _ciudadanos = await getCiudadanos({ q });
  //       if (_ciudadanos.results.length) {
  //         const [selected] = _ciudadanos.results;
  //         form.setFieldsValue({
  //           ciudadano: selected.id,
  //         });
  //         setCiudadanoFound([selected]);
  //       } else if (!_ciudadanos.results.length) {
  //         message.info('No se encontró ciudadano');
  //       }
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err, setLoading);
  //   }
  // };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible
          ? (
            <Table
              cols={columns}
              mobileColumns={[columns[0], columns[1]]}
              data={data.results || []}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              rowKey="id"
              baseURI={baseURI}
              permission={permission}
              pagination={false}
              paginationCallback={fetchData}
              count={data.count}
              currentPage={currentPage}
              hasAllViewPermission={hasAllViewPermission}
            />
          ) : (
            <Col span={24} style={{ height: '100%' }}>
              <Card
                className="form-container"
                title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} expediente de mercado`}
                extra={(
                  <FormSubmitControls
                    onFinish={onFinish}
                    onCancel={onCancel}
                    allowSaveAndContinue
                    onCancelText="Cancelar"
                    permission={permission}
                  />
                )}
                bordered={false}
              >
                <Tabs
                  type="card"
                >
                  <TabPane
                    tab={(
                      <span>
                        <InfoCircleOutlined />
                        Información General
                      </span>
                    )}
                    key="general"
                    forceRender
                  >
                    <Form
                      name="general"
                      layout="vertical"
                      form={form}
                      onFinish={() => onFinish()}
                      scrollToFirstError
                    >
                      <Row gutter={10}>
                        {!!selectedRowKeys.length && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              name="clave"
                              label="clave"
                              rules={rules.required}
                              hasFeedback
                              required

                            >
                              <Input allowClear disabled />
                            </Form.Item>
                          </Col>
                        )}
                        <InputSearchPro
                          label="RFC de Contribuyente"
                          name="q_contribuyente"
                          required
                          onClickAdvanced={() => {
                            setVisibleBusquedaPadrones(true);
                          }}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchContribuyente(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidateContribuyente();
                              }
                            },
                          }}
                          resultProps={{
                            label: 'Contribuyente',
                            name: 'contribuyente',
                            dataSource: contribuyenteFound,
                            labelProp: 'nombre_completo',
                            onClearConfirm: resetAndValidateContribuyente,
                            // eslint-disable-next-line max-len
                            // contentConfirm: 'Si se realiza, se quitará cualquier relación con el Mercado.',
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 8,
                            },
                          }}
                        />
                        {/* <InputSearchPro
                          label="Ciudadano"
                          name="q"
                          onClickAdvanced={() => {
                            setTipoDePadron(1);
                            setVisibleBusquedaPadrones(true);
                          }}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 8,
                          }}
                          inputProps={{
                            normalize: (e) => toUpper(e),
                            onPressEnter: () => searchCiudadano(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidate();
                              }
                            },
                          }}
                          resultProps={{
                            name: 'ciudadano',
                            label: 'Ciudadano',
                            dataSource: ciudadanoFound,
                            labelProp: 'nombre_completo',
                            onClear: resetAndValidate,
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                          }}
                        /> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="contribuyente_rfc"
                            label="RFC"
                          >
                            <Input allowClear disabled />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={16}>
                          <Form.Item
                            name="nombre_comercio"
                            label="Nombre de Comercio"
                            hasFeedback
                            required
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="mercado"
                            label="Mercado"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={mercadosTemp.results?.length
                                ? mercadosTemp : mercados.current}
                              usingExternalDataSource={Boolean(mercadosTemp.results?.length)}
                              labelProp="descripcion"
                              onClear={() => { form.resetFields(['mercado']); setMercadosTemp({ results: [] }); }}
                              pagination={{
                                getter: getMercados,
                                setter: (dataSource) => {
                                  mercados.current = dataSource;
                                },
                                config: { auto: true, qName: 'descripcion', selfValue: mercado },
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipos_de_mercados"
                            label="Tipo de puesto"
                            hasFeedback
                          >
                            <Select dataSource={tipoDeMercado} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="zona"
                            label="Zona"
                            hasFeedback
                          >
                            <Select dataSource={zonasDeMercado} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="local"
                            label="Numero de Puesto"
                            hasFeedback
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="num_locales"
                            label="Número de locales"
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="giro_principal"
                            label="Giro Principal"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select dataSource={giros} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            decimal
                            name="mts_largo"
                            label="Metros de largo"
                            allowZero
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            decimal
                            name="mts_ancho"
                            label="Metros de ancho"
                            allowZero
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="superficie_local"
                            label="Superficie Local"
                          />
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="giros"
                            label="Giros secundarios"
                            hasFeedback
                          >
                            <Select dataSource={giros} mode="multiple" />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="dias_laborales"
                            label="Días laborales"
                            hasFeedback
                          >
                            <Select mode="multiple" dataSource={dias} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="num_dias"
                            label="Numero de dias laborales"
                            hasFeedback
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="plaza"
                            label="Plaza"
                            hasFeedback
                          >
                            <Select dataSource={plazasDeMercado} />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="ultima_fecha_pagada"
                            label="Ultima fecha pagada"
                            hasFeedback
                          >
                            <DatePicker format={DATE_FRONTEND_FORMAT} placeholder="" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="ultimo_anio_pagado"
                            label="Ultimo año pagado"
                            hasFeedback
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            decimal
                            name="expediente_licencia"
                            label="Expediente de Licencia"
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_expedicion"
                            label="Fecha de expedición"
                            hasFeedback
                          >
                            <DatePicker format={DATE_FRONTEND_FORMAT} placeholder="" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="observaciones"
                            label="Observaciones"
                            hasFeedback
                          >
                            <Input.TextArea autoSize={{ minRows: 3, maxRows: 3 }} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="estados_globales"
                            label="Estado"
                            hasFeedback
                          >
                            <Select
                              disabled={!selectedRowKeys.length}
                              dataSource={estadosGlobales}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </TabPane>
                </Tabs>
              </Card>
            </Col>
          )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Expediente de mercado seleccionado"
          loading={loading}
        />
        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaPadrones}
          setVisible={setVisibleBusquedaPadrones}
          callback={fetchContribuyente}
          tipoDePadron={15}
          allowAdd={false}
        />
      </Spin>
    </Row>
  );
};

export default ExpedienteDeMercado;
